import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function PrintIFrame({ url }) {
  const CheckUrl = () => {
    if (!_.isEmpty(url) && !_.includes(url, undefined)) {
      return url;
    }
    return '';
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 px-0">
          <iframe
            src={CheckUrl()}
            title="print-tab"
            className="w-100"
            frameBorder="0"
            style={{ minHeight: '600px' }}
          />
        </div>
      </div>
    </div>
  );
}

PrintIFrame.propTypes = {
  url: PropTypes.string,
};

PrintIFrame.defaultProps = {
  url: '',
};

export default PrintIFrame;
